<template>
  <div>
    <el-dialog class="toast" :visible="isOpen" :show-close="false">
      <div slot="title" class="jumFpeedback_head">
        <img src="/img/logo.e85e07f3.png" alt="" />
        <b></b>
        <span>授权</span>
      </div>
      <div class="jumpFeedback_body">
        <div class="title">
          <span class="blod">瑞网青年导演大赛</span>火热进行中,请参与投票或报名参赛
        </div>
        <div class="user">
          <el-input :value="args.mobile" disabled />
        </div>
        <div class="code">
          <el-input v-model="code" placeholder="请输入验证码" />
          <el-button type="primary" @click="btnTimeFn">
            {{ isClickBtn ? `重新发送${time}s` : '获取验证码' }}
          </el-button>
        </div>
        <div class="regType">
          <el-select v-model="userType" placeholder="请选择您的用户类型" size="medium">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.text }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="loginBtn" @click="regDealFn">
          <span>确认</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'BridgeIframe',
  props: ['loginData'],
  data() {
    return {
      isOpen: false,
      args: { mobile: '', password: '', phoneCode: '', roleid: '' },
      options: [
        { value: 2, label: '参赛者', text: '可上传作品、可观看、无法投票' },
        { value: 3, label: '普通用户', text: '无法上传作品、可观看、可投票' }
      ],
      code: '',
      isClickBtn: false,
      time: 60,
      userType: ''
    }
  },
  watch: {
    loginData(val) {
      if (val && val.phone && val.pwd) {
        this.args.mobile = val.phone
        this.args.password = val.pwd
        if (window.miniSign) {
          window.miniSign('isPhoneExist', this.args, (result) => {
            if (result) {
              window.miniSign('signIn', this.args, () => { this.isOpen = false })
            } else {
              this.isOpen = true
            }
          })
        }
      } else {
        this.isOpen = false
      }
    }
  },
  methods: {
    btnTimeFn() {
      if (this.isClickBtn) return
      this.isClickBtn = true
      if (window.miniSign) {
        window.miniSign('sendPhoneCode', this.args, (result) => {
          if (!result) {
            this.$message({ message: '验证码发送失败，请稍后重发！', type: 'warning' })
          }
        })
      }
      const timer = setInterval(() => {
        this.time--
        if (this.time === 0) { clearInterval(timer); this.time = 60; this.isClickBtn = false }
      }, 1000)
    },
    regDealFn() {
      if (this.code && this.userType) {
        this.args.phoneCode = this.code
        this.args.roleid = this.userType
        if (window.miniSign) {
          window.miniSign('signUp', this.args, (result) => {
            if (result) {
              this.$message({ message: '授权成功', type: 'success', onClose: () => { this.isOpen = false } })
            } else {
              this.$message({ message: '授权失败', type: 'warning', onClose: () => { this.isOpen = false } })
            }
          })
        }
      } else {
        this.$message({ message: '请完善信息', type: 'warning' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  .jumFpeedback_head {
    display: flex;
    align-items: center;
    img { height: 30px; }
    b { width: 1px; height: 20px; background: #ddd; margin: 0 10px; }
    span { font-size: 18px; font-weight: bold; }
  }

  .jumpFeedback_body {
    padding: 20px 40px;

    .title { font-size: 14px; margin-bottom: 20px; .blod { font-weight: bold; } }
    .user { margin-bottom: 15px; }
    .code { display: flex; margin-bottom: 15px; .el-input { flex: 1; margin-right: 10px; } }
    .regType { margin-bottom: 20px; .el-select { width: 100%; } }

    .loginBtn {
      width: 100%;
      height: 44px;
      background: #d02f3d;
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      span { color: #fff; font-size: 16px; }
    }
  }
}
</style>
